import type { Export } from "./Export"
import type { FormUpdatableRenderState } from "./FormAppRelayInterface"
import type { ImportWriteMode } from "./ImportWriteMode"
import type { RenderSliceSettings } from "./Setting"
import type { UserIdentity } from "./UserIdentity"

export interface RenderForm {
	flowXml: string
	export: Export|null
	writeMode: ImportWriteMode
	// optional: restrict view to only one page of the form
	onlyPageIdx?: number
}

export enum RenderPlatform {
	Native = 'native',
	Web = 'web',
}

export type BackcompatRenderState = { theme: object } & FormUpdatableRenderState & RenderSliceSettings & {
	// none of the historic renderers care what is in the theme;
	// the whole object just gets spread into the Emotion theme
	// within the renderer.  to avoid backporting the entire theme system
	// into backcompat when not useful, this type is overridden later
	// in formrender.
	// theme: Partial<FusionThemeOverridable>
	theme: object
	t1NavOpen: boolean
	/**
	 * @deprecated: 20251120
	 * was used only for pre-offline draft saves;
	 * as of full offline, no longer populated
	 */
	// loadedWorkItem: WorkItem|null
	loadedWorkItem: null
	formLoading: boolean
	form: RenderForm|null
	platform: RenderPlatform
	authedIdentity: UserIdentity|null
	impersonatingIdentity: UserIdentity|null
	locationLoading: boolean
	importLocation: string|null
	importLoading: boolean
	// branch preview: the form is never saved (absent from older frontends)
	previewMode?: boolean
}

export const AppFormRelayForwardUpdatedRenderStateActionType = 'appFormRelay/forwardUpdatedRenderState'
